<app-gc-header [iconName]="'house'" [titleString]="'homeLabel' | translate" />

<div class="home-container">
  <div class="home-header">
    <gc-text [variant]="'sectionTitle'">{{
      'dpWelcomeHeader' | translate
    }}</gc-text>
    <ipo-text>{{ 'dpWelcomeText' | translate }}</ipo-text>
    <gc-button (clicked)="goToGuides()">{{
      'goToGuidesText' | translate
    }}</gc-button>
    <gc-button (clicked)="goToInstructions()">{{
      'goToVideoInstructionsText' | translate
    }}</gc-button>
  </div>

  @if (latestEntry(); as entry) {
    <div class="home-changelog-container">
      <gc-text [variant]="'minorHeading'">{{
        'latestUpdate' | translate
      }}</gc-text>
      <app-changelog-entry-card [entry]="entry" />
      <gc-button (clicked)="goToChangelog()">{{
        'goToChangelog' | translate
      }}</gc-button>
    </div>
  }

  <ng-template #overviewImageBody>
    <img
      src="./assets/images/dp-system-overview.png"
      alt="deliveryPortal-overview"
      class="overview-image"
  /></ng-template>

  @if (isUserFederated) {
    <app-email-section [appOptions]="getUserApps()"></app-email-section>
  }
</div>
